import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Alert, Box, Button, Typography } from "@mui/material";
import propTypes from "prop-types";

const MissingDateOfBirthAlert = ({ user }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!user || user.dateOfBirth) return null;

  return (
    <Alert
      severity="info"
      sx={{
        backgroundColor: "customColors.bg2",
        marginBottom: 2,
        alignItems: "flex-start",
        border: "1px solid",
        borderColor: "primary.light",
        borderRadius: 2,
        "& .MuiAlert-icon": { marginTop: 0.5 },
        "& .MuiAlert-message": { width: "100%" },
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "stretch", sm: "center" },
          justifyContent: "space-between",
          gap: 1.5,
        }}
      >
        <Typography variant="body1" color="primary" sx={{ lineHeight: 1.7 }}>
          {t("settingsModule.missingDateOfBirthDisclaimer")}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="medium"
          onClick={() => navigate("/settings/user-profile")}
          sx={{
            flexShrink: 0,
            minWidth: { xs: "100%", sm: 150 },
            alignSelf: { xs: "stretch", sm: "center" },
          }}
        >
          {t("settingsModule.addDateOfBirth")}
        </Button>
      </Box>
    </Alert>
  );
};

MissingDateOfBirthAlert.propTypes = {
  user: propTypes.object,
};

export default MissingDateOfBirthAlert;
